import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { palette } from 'styles/theme';

const BadgeNumber = styled(Box)(() => ({
  borderRadius: '50%',
  fontWeight: 'bold',
  height: 32,
  width: 32,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: palette.primary.bg,
  color: palette.primary.main
}));

export default BadgeNumber;
